import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import RefillReducer from './RefillManagementReducer';
import InventoryReducer from './InventoryReducer';
import AllOrdersReducer from './AllOrdersReducer';
import DispatchReducer from './DispatchReducer';

export default combineReducers({
    OrderState: AllOrdersReducer,
    AppState: AppReducer,
    RefillState: RefillReducer,
    InventoryState: InventoryReducer,
    DispatchState: DispatchReducer,
});



// WEBPACK FOOTER //
// ./src/Reducer/index.js